import { BlockVariant } from '@life-moments/lifehub-components';

export const getBlockVariantsOptions = (blockVariants: BlockVariant[]) =>
  blockVariants.map(variant => ({
    id: variant.name,
    label: variant.displayName,
    value: variant,
    disabled: false
  }));
